// backend/src/services/okx.js::toInstId ile AYNI quote listesi — sadece görüntüleme amaçlı (birim
// etiketleri), gerçek işlem mantığı zaten backend'de tgtCcy:'quote_ccy' ile jenerik çalışıyor. Bu
// liste backend'dekiyle senkron kalmalı (yeni bir fiat/quote eklenirse ikisi birden güncellenmeli).
const QUOTE_ASSETS = ['USDT', 'USDC', 'BTC', 'ETH', 'TRY'];

// USDTTRY -> TRY (USDT burada BASE'tir), BTCUSDT -> USDT, AXS-USDT -> USDT. Eşleşme yoksa (zaten
// tire'li ve tanınan bir quote'la bitmiyorsa ya da hiç quote bulunamazsa) sembolü olduğu gibi döner.
export function guessQuoteAsset(symbol) {
  if (!symbol) return '';
  const raw = symbol.toUpperCase().trim();
  const s = raw.endsWith('-SWAP') ? raw.slice(0, -5) : raw;
  if (s.includes('-')) return s.split('-').pop();
  for (const quote of QUOTE_ASSETS) {
    if (s.endsWith(quote) && s.length > quote.length) return quote;
  }
  return s;
}
